import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { ILastReleases } from '../Interfaces/ILastReleases';
import { PropertiesService } from '../services/properties-services';
import { NotificationService } from '../../../../core/services/notification/notification.service';

@Component({
	selector: 'app-last-release',
	templateUrl: './last-release.component.html',
	styles: [],
})
export class LastReleaseComponent implements OnInit {
	listData: Array<ILastReleases> = [];
	loading = false;
	station: string = 'TABLE';
	columns: Array<any> = ['strcreationdate', 'description'];
  displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
  
  constructor(
	private propertyService: PropertiesService,
	private notificationService: NotificationService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
	this.loading = true;
    this.propertyService.GetLastReleases().subscribe(
		(result: TransactionResult<ILastReleases[]>) => {
			this.loading = false;
			if (result.success) {
        		this.listData = result.data;
        		this.listData.forEach(element => {
					element.strcreationdate = this.datePipe.transform(element.date, "yyyy-MM-dd HH:mm:ss");
				});
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => { this.ErrorAlert(error); this.loading = false},
	);
  }

  ErrorAlert(message: any) {
	this.notificationService.AddAlert({
		icon: 'all_inbox',
		title: 'Error',
		message: message,
		shown: true,
	});
}
}
